<template>
  <div class="index-main">
    <Header/>
    <div class="carousel-box">
      <div class="carousel">
        <el-carousel trigger="click" height="465px">
          <el-carousel-item v-for="(item,index) in bannerData" :key="index">
            <a 
              :href="item.url || item.link || 'javascript:;'"
              :target="(item.url || item.link) && ((item.url || item.link).startsWith('http') ? '_blank' : '_self')"
              @click.prevent="handleBannerClick(item)"
              style="display: block; width: 100%; height: 100%; cursor: pointer;">
              <img 
                class="carousel-item-img" 
                :src="item.image" 
                alt=""
                style="pointer-events: none;">
            </a>
          </el-carousel-item>
        </el-carousel>
        <div class="main-1200-width">
          <div class="index-menu">
            <div class="index-menu-top">全部商品</div>
            <div class="index-menu-main">
              <div class="index-menu-item el-icon el-icon-arrow-right" v-for="(item1,index1) in menuData" :key="index1">
                <router-link :to="{path: 'Screen', name: 'Screen', params: {cate_id: item1.id}}">{{ item1.name }}</router-link>
                <div class="index-menu-item-more">
                  <div class="index-menu-more-item" v-for="(item2,index2) in item1.children" :key="index2">
                    <span>
                      <router-link class="index-menu-more-item-title" :to="{path: 'Screen', name: 'Screen', params: {cate_id: item2.id}}">{{ item2.name }}</router-link>
                    </span>
                    <span v-for="(item3,index3) in item2.children" :key="index3">
                      <router-link :to="{path: 'Screen', name: 'Screen', params: {cate_id: item3.id}}">{{ item3.name }}</router-link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-1200-width padding-bottom-40">
      <!-- 秒杀专区：仅在有进行中的活动且能展示到商品时显示（已结束活动不再占位） -->
      <div class="seckill-home" v-if="seckillItems.length">
        <div class="seckill-header">
          <div class="seckill-header-left">
            <div class="seckill-header-icon" aria-hidden="true" />
            <div class="seckill-header-text">
              <div class="title">秒杀专区</div>
              <div class="sub">精选限时抢购 · 先到先得</div>
            </div>
          </div>
          <el-button type="danger" size="small" round class="seckill-more-btn" @click="goSeckillMore">
            更多秒杀
          </el-button>
        </div>
        <div class="seckill-body">
          <div
            class="seckill-item"
            v-for="it in seckillItems"
            :key="`${it.activity_id}-${it.goods.id}`"
            @click="goSeckillGoods(it.activity, it.goods)"
          >
            <div class="seckill-cover">
              <img class="seckill-img" :src="$url.cdn(it.goods.image)" :alt="it.goods.title" />
              <div class="seckill-mark seckill-mark--left">{{ it.activity_title }}</div>
              <div class="seckill-mark seckill-mark--right">{{ remainText(it.activity) }}</div>
            </div>
            <div class="seckill-card-body">
              <div class="seckill-name" :title="it.goods.title">{{ it.goods.title }}</div>
              <div class="seckill-price-row" v-if="is_login">
                <div class="seckill-price-block">
                  <span class="seckill-price-tag">秒杀价</span>
                  <span class="seckill-price">
                    <span class="seckill-price-y">¥</span>{{ formatSeckillGoodsPrice(it.goods) }}
                  </span>
                </div>
                <div v-if="seckillRefText(it.goods)" class="seckill-ref-block">
                  <span class="seckill-ref-label">日常价</span>
                  <span class="seckill-ref">¥{{ seckillRefText(it.goods) }}</span>
                </div>
              </div>
              <div class="seckill-price-row" v-else>
                <span class="seckill-price seckill-price--mask">¥ ****</span>
              </div>
              <span class="seckill-action">去秒杀</span>
            </div>
          </div>
        </div>
      </div>

      <div class="index-column" v-for="(item,index) in indexData" :key="index">
        <div class="index-column-header">
          <div class="index-column-title"><span>{{ item.name }}</span></div>
          <div class="index-column-desc">{{ item.desc }}</div>
        </div>
        <div class="flool-cle index-column-main">
          <div class="sellers sell_ons" v-for="(item2,index2) in item.goods" :key="index2" v-if="index2 < 1">
            <div class="best">
              <div class="best-about">
                <div class="best_img best_img2">
                  <router-link :to="{ name: 'GoodsDetail', query: { id: item2.id } }"><img :src="$url.cdn(item2.image)" :alt="item2.title"></router-link>
                </div>
                <div class="best_name">
                  <router-link :to="{ name: 'GoodsDetail', query: { id: item2.id } }"><span>{{ item2.title }}</span></router-link>
                </div>
                <div class="best_Introduction">
                  <div class="intr-t">{{ item2.subtitle }}</div>
                  <div class="intr-b">{{ item2.desc }}</div>
                </div>
                <div class="price" v-if="is_login">
                  <span>¥</span><em>{{ formatPrice(item2.price) }}</em>
                </div>
                <div class="price" v-else>
                  价格：**** <router-link :to="{ name: 'Login', query: { redirect: $route.fullPath } }">登录后查看</router-link>
                </div>
                <div class="imm-button">
                  <router-link :to="{ name: 'GoodsDetail', query: { id: item2.id } }"><span>立即抢购</span></router-link>
                </div>
                <div class="tag" v-if="item2.sales > 10">
                  <img src="@/assets/hot.png" alt="热卖">
                </div>
              </div>
            </div>
          </div>
          <div class="sellers sellers2" v-for="(item2,index2) in item.goods" :key="index2" v-if="index2 > 0">
            <div class="best">
              <div class="best-about">
                <div class="best_img best_img2 best_img3">
                  <router-link :to="{ name: 'GoodsDetail', query: { id: item2.id } }"><img :src="$url.cdn(item2.image)" :alt="item2.title"></router-link>
                </div>
                <router-link class="intr-t intr-t3 index-goods-link" :to="{ name: 'GoodsDetail', query: { id: item2.id } }">{{ item2.title }}</router-link>
                <div class="price prices" v-if="is_login">
                  <span>¥</span><em>{{ formatPrice(item2.price) }}</em>
                </div>
                <div class="price prices" v-else>
                  价格：**** <router-link :to="{ name: 'Login', query: { redirect: $route.fullPath } }">登录后查看</router-link>
                </div>
                <div class="tag">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import Header from "@/globalComponents/Header";
import Footer from "@/globalComponents/Footer";
import categoryApi from "@/api/category.js";
import appApi from "@/api/app.js";
import goodsApi from "@/api/goods.js";
import activityApi from "@/api/activity.js";
import { isSeckillActivityLive } from "@/units/seckillLive.js";
import {
  formatSeckillActivityPriceOnlyDisplay,
  formatSeckillCatalogFloorLineDisplay,
  getSeckillRefPriceText,
} from "@/units/activityGoodsPrice.js";
import {
  enrichGoodsListWithActivityDetail,
  normalizeActivityListRows,
} from "@/units/enrichSeckillGoodsFromDetail.js";
export default {
  data() {
    return {
      active: 0,
      menuData: [],
      indexData: [],
      bannerData: [],
      seckillActivities: [],
      seckillGoodsMap: {}, // activity_id -> goods[]
      nowTs: Math.floor(Date.now() / 1000),
      timerId: null,
    };
  },
  computed: {
    ...mapGetters(['is_login']),
    seckillItems() {
      // 打平：以商品为中心展示；随 nowTs 刷新，活动结束后自动从首页移除
      const now = Number(this.nowTs || 0)
      const items = []
      for (const a of this.seckillActivities) {
        if (!a || !a.id) continue
        if (!isSeckillActivityLive(a, now)) continue
        const goodsList = this.getSeckillGoods(a.id)
        for (const g of goodsList) {
          items.push({
            activity_id: a.id,
            activity: a,
            activity_title: a.title || `秒杀活动 #${a.id}`,
            goods: g,
          })
        }
      }
      // 首页三列布局，仅展示 3 个；完整列表见「更多秒杀」/Seckill
      return items.slice(0, 3)
    },
  },
  created() {
    this.getData();  //step1
    this.timerId = setInterval(() => {
      this.nowTs = Math.floor(Date.now() / 1000)
    }, 1000)
  },
  beforeDestroy() {
    if (this.timerId) clearInterval(this.timerId)
  },
  methods: {
    formatPrice(e) {
        return e.length === 1 ? e[0] : e.join('~');
    },
    /** 秒杀卡片主行：仅活动价（与日常价分行，避免主数字被日常兜底占满） */
    formatSeckillGoodsPrice(goods) {
      const act = formatSeckillActivityPriceOnlyDisplay(goods);
      return act || "—";
    },
    /** 次行：同档划线价；无则各档日常最低价（可与秒杀价同时展示） */
    seckillRefText(goods) {
      return getSeckillRefPriceText(goods) || formatSeckillCatalogFloorLineDisplay(goods);
    },
    // 处理轮播图点击跳转
    handleBannerClick(item) {
      // 优先使用 url，其次使用 link
      const url = item.url || item.link || item.href;
      
      if (!url) {
        return;
      }
      
      // 判断是否是外部链接
      if (url.startsWith('http://') || url.startsWith('https://')) {
        window.open(url, '_blank');
      } else {
        // 内部路由跳转
        this.$router.push(url);
      }
    },
    //step1:获取数据
    async getData() {
      let {data: bannerData} = await appApi.getSlideList()
      this.bannerData = bannerData;

      let {data: menuData} = await categoryApi.list()
      this.menuData = menuData.children || []

      await this.getIndexData()
      await this.getSeckillHome()
    },
    goSeckillMore() {
      // 直接进入秒杀活动入口页（可看到所有秒杀活动）
      this.$router.push({ name: 'Seckill' })
    },
    goSeckillList(a) {
      if (!a || !a.id) return
      this.$router.push({ name: 'SeckillList', query: { activity_id: a.id } })
    },
    goSeckillGoods(a, g) {
      if (!a || !a.id) return
      this.$router.push({
        name: 'GoodsDetail',
        query: { id: g.id, activity_id: a.id }
      })
    },
    getSeckillGoods(activityId) {
      return this.seckillGoodsMap[String(activityId)] || []
    },
    remainText(activity) {
      if (!activity) return ''
      const end = Number(activity.end_time || 0)
      const now = Number(this.nowTs || 0)
      const remain = end - now
      if (!end || !Number.isFinite(remain) || remain <= 0) return '活动已结束'
      const h = Math.floor(remain / 3600)
      const m = Math.floor((remain % 3600) / 60)
      const s = Math.floor(remain % 60)
      const pad = (n) => (n < 10 ? `0${n}` : `${n}`)
      return `距结束 ${pad(h)}:${pad(m)}:${pad(s)}`
    },
    async loadSeckillGoods(activityId) {
      const key = String(activityId)
      if (this.seckillGoodsMap[key] && this.seckillGoodsMap[key].length) return
      const { data: goodsData } = await goodsApi.activityList({
        activity_id: activityId,
        page: 1,
        list_rows: 3
      })
      const pageData = goodsData || {}
      const rows = normalizeActivityListRows(pageData.data || [])
      this.$set(this.seckillGoodsMap, key, rows)
      enrichGoodsListWithActivityDetail(rows, activityId, 3).then((enriched) => {
        if (this.seckillGoodsMap[key] === rows) {
          this.$set(this.seckillGoodsMap, key, enriched)
        }
      })
    },
    async getSeckillHome() {
      try {
        // 后端未提供活动列表接口时，避免报错导致首页崩溃
        if (!activityApi || typeof activityApi.list !== 'function') {
          this.seckillActivities = []
          this.seckillGoodsMap = {}
          return
        }
        const { data } = await activityApi.list({ type: ['seckill'], list_rows: 10 })
        const list = (data && (data.data || data.list)) || []
        if (!Array.isArray(list) || !list.length) {
          this.seckillActivities = []
          this.seckillGoodsMap = {}
          return
        }
        const now = Math.floor(Date.now() / 1000)
        const liveList = list.filter((x) => isSeckillActivityLive(x, now))
        this.seckillActivities = liveList.slice(0, 3)
        this.seckillGoodsMap = {}
        await Promise.all(this.seckillActivities.map(a => a && a.id ? this.loadSeckillGoods(a.id) : Promise.resolve()))
      } catch (e) {
        this.seckillActivities = []
        this.seckillGoodsMap = {}
      }
    },
    async getIndexData() {
      let indexData = []
      // this.menuData.forEach(async item => {
      //   let {data} = await goodsApi.list({ category_id: item.id, list_rows: 19 })

      //   indexData.push({
      //     name: item.name,
      //     description: item.description,
      //     id:item.id,
      //     goods: data.data
      //   })
      // })
      let {data} = await categoryApi.indexData()
      this.indexData = data
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
